import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const useProjectPhotos = (slug) =>
  useQuery({
    queryKey: ["project-photos", slug ?? "all"],
    queryFn: async () => {
      const { data } = await api.get("/project-photos", { params: slug ? { project: slug } : {} });
      return data.map((p) => ({ ...p, src: `${BACKEND}${p.url}`, alt: p.caption || "Site photo" }));
    },
  });

export const projectCover = (project, uploaded = []) =>
  project.images[0] || uploaded.find((u) => u.project_slug === project.slug) || null;
